import { Check } from "lucide-react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Button } from "@repair/ui";

export function SuccessPage() {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const id = params.get("id") || "";
  const orderNo = params.get("order_no") || "";
  return (
    <div className="customer-page success-page">
      <div>
        <span className="success-page__icon"><Check size={28} /></span>
        <h1>报修已提交</h1>
        <p>售后受理后，最新状态会显示在工单详情。</p>
        <code>{orderNo}</code>
        <div className="success-actions">
          <Button variant="secondary" onClick={() => navigate("/orders")}>我的返修</Button>
          <Button onClick={() => navigate(id ? `/orders/${encodeURIComponent(id)}` : "/orders")}>查看工单</Button>
        </div>
      </div>
    </div>
  );
}
